export default __webpack_public_path__ + "static/media/mc-3-rMAX.b35d80d2.avif";